// AppRoutes.tsx
import { FC } from "react";
import { Routes, Route } from "react-router-dom";
import Admin from "../components/Admin/Admin";
import AdminProtectedRoute from "./AdminProtectedRoute";
import ReportFlow from "../components/SubmitTip/ReportFlow";
import Landing from "../components/Landing/Home";
import SafetyAndSecurity from "../components/Landing/Safety/SafetyAndSecurity";
import TermsAndConditions from "../components/Landing/Terms/TermsAndConditions";
import PrivacyAndCookies from "../components/Landing/Privacy/PrivacyAndCookies";
import TrackReport from "../components/TrackReport";
import User from "../components/User/User";
import UserReportView from "../components/User/UserDashboard/UserReportView";
import UserProtectedRoute from "./UserProtectedRoute";
import NotFoundPage from "../components/Landing/NotFound";

const AppRoutes: FC = () => {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/privacy" element={<PrivacyAndCookies />} />
      <Route path="/safety" element={<SafetyAndSecurity />} />
      <Route path="/terms" element={<TermsAndConditions />} />
      <Route path="/submit" element={<ReportFlow />} />
      <Route path="/report/track/:id" element={<TrackReport />} />
      <Route path="/admin/login" element={<Admin view="login" />} />
      <Route path="/login" element={<User view="login" />} />
      <Route path="/register" element={<User view="register" />} />

      <Route path="/report/:id" element={<UserReportView />} />
      <Route
        path="/dashboard"
        element={
          <UserProtectedRoute>
            <User view="dashboard" />
          </UserProtectedRoute>
        }
      />
      <Route
        path="/forgot-password"
        element={
          // <UserProtectedRoute>
          <User view="forgot-password" />
          // </UserProtectedRoute>
        }
      />

      <Route
        path="/verify-email"
        element={
          <UserProtectedRoute>
            <User view="verify-email" />
          </UserProtectedRoute>
        }
      />

      <Route
        path="/profile"
        element={
          <UserProtectedRoute>
            <User view="profile" />
          </UserProtectedRoute>
        }
      />

      <Route
        path="/profile/:section"
        element={
          <UserProtectedRoute>
            <User view="profile" />
          </UserProtectedRoute>
        }
      />

      <Route
        path="/admin/report/:id"
        element={
          <AdminProtectedRoute>
            <Admin view="reportView" />
          </AdminProtectedRoute>
        }
      />
      <Route
        path="/admin/*"
        element={
          <AdminProtectedRoute>
            <Admin view="dashboard" />
          </AdminProtectedRoute>
        }
      />
      {/* 404 route  */}
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
};

export default AppRoutes;
